import { render, staticRenderFns } from "./optionSettings.vue?vue&type=template&id=fe5e5816&scoped=true&"
import script from "./optionSettings.vue?vue&type=script&lang=js&"
export * from "./optionSettings.vue?vue&type=script&lang=js&"
import style0 from "./optionSettings.vue?vue&type=style&index=0&id=fe5e5816&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5e5816",
  null
  
)

export default component.exports